import { TypographyP } from "@/components/typography/P";
import { ProjectTemplate } from "../../types/app.type";
import { BackgroundWaveLine3Flipped } from "./BackgroundWaveLine3Flipped";

type Props = {
  project: ProjectTemplate;
  selectedProjectForAppName: string | null;
  handleProjectSelection: (projectName: string) => void;
};

const CreateAppProject = ({
  project,
  selectedProjectForAppName,
  handleProjectSelection
}: Props) => {
  return (
    <label
      key={project.id}
      htmlFor={project.name}
      className="h-full w-full p-3 flex flex-col items-start gap-2 rounded-lg bg-brand-gray-50 dark:bg-brand-gray-800 border border-brand-gray-100 dark:border-brand-gray-200 hover:border-brand-gray-200 dark:hover:border-brand-gray-300 group relative overflow-hidden has-[:checked]:border-primary has-[:checked]:ring-1 has-[:checked]:ring-primary cursor-pointer"
    >
      <div className="w-full grid grid-cols-[1fr_3fr] items-start gap-2">
        {project.image ? (
          <div className="size-14 rounded-full overflow-hidden border border-brand-gray-100 dark:border-brand-gray-200">
            <img
              src={project.image}
              alt=""
              loading="lazy"
              className="size-14 rounded-full object-cover object-center transition duration-200 group-hover:scale-110"
            />
          </div>
        ) : (
          <div className="relative size-14 rounded-full overflow-hidden bg-white dark:bg-brand-gray-900 border border-brand-gray-100 dark:border-brand-gray-200">
            <BackgroundWaveLine3Flipped className="absolute size-14 rotate-45 -top-8 -left-2 rounded-full text-brand-gray-900 dark:text-brand-gray-50 object-cover object-center transition duration-200 group-hover:scale-110" />
          </div>
        )}
        <h2 className="mt-1 text-sm font-semibold leading-4 tracking-wide text-brand-gray-700 dark:text-brand-gray-50 text-pretty line-clamp-3">
          {project.name}
        </h2>
      </div>
      <TypographyP className="text-sm text-left text-brand-gray-600 dark:text-brand-gray-100 text-pretty line-clamp-4">
        {project.description}
      </TypographyP>
      <input
        type="radio"
        name={project.name}
        value={project.name}
        id={project.name}
        className="sr-only"
        onChange={(e) => handleProjectSelection(e.target.value)}
        checked={selectedProjectForAppName === project.name}
      />
    </label>
  );
};

export default CreateAppProject;
